import "../../../CSS/main.css";

import PaidDigitalImg from "../../../Images/Schools&Programmes/Paid Digital.jpeg";
import { Link } from "react-router-dom";
import MetaTags from "../../MetaInfo/MetaTags";

const PaidDigital = () => {
  // const handleBrochure = (SEOBrochure) => {
  //   window.open(SEOBrochure);
  // };

  return ( 
    <>
      <MetaTags
        title={"Online Digital Marketing Training in Telugu | ND Skills"}
        Description={
          "Join New Directions Skills for practical digital marketing training in Telugu at just ₹5999. Get certified and boost your career. Enroll now!"
        }
        Keywords={
          "digital marketing training, digital marketing course, digital marketing in Telugu, SEO training in Telugu, Google ads course, social media marketing, online digital marketing course, digital marketing course ₹5999, new directions skills, digital marketing certification, Telugu digital marketing training, practical digital marketing course, best digital marketing course in Telugu."
        }
        href={"https://ndskills.in/paid-digital-marketing"}
      />
      <img
        src={PaidDigitalImg}
        alt="SEOBanner Img"
        className="img-fluid w-100"
      />

      <div className="container my-md-5">
        <div className="bg-white text-muted md-p-5 rounded-4 d-flex flex-column  seo-title gap-md-3 ">
          <h1 className=" textColor2 text-lg-center">
            Learn Digital Marketing in Telugu – Just ₹5999/- for 2 Months!
          </h1>
          <p className="">
            Are you passionate about building a career in Digital Marketing? Do
            you want to learn in a language you're comfortable with – Telugu?
            Look no further! New Direction Skills brings you a comprehensive
            Digital Marketing Course in Telugu, designed to turn beginners into
            professionals – all for just ₹5999/-.
          </p>

          <h2 className="textColor2 ">Why Learn Digital Marketing?</h2>
          <p>
            Digital Marketing is one of the fastest-growing fields today.
            Whether you want to start freelancing, grow your own business, or
            land a job in top companies, digital skills are the need of the
            hour. From social media strategies to paid advertising, everything
            today runs on digital platforms.
          </p>
          <p>
            Our course helps you build a strong foundation and teaches practical
            tools and techniques that are highly in-demand.
          </p>
        </div>

        {/* ************************* What You Will Learn: ************************* */}

        <div className="bg-white p-2 p-md-5 rounded-4 shadow-sm Course-Highlights border border-light ">
          <h3 className="textColor2  fw-bold mb-4 text-center">
            🎯 What You Will Learn
          </h3>

          <div className="row g-3 g-md-4">
            <div className="col-md-6">
              <div className="d-flex align-items-center justify-content-center bg-light rounded-4 p-3 shadow-sm h-100">
                <span className="fs-3 me-3">📚</span>
                <div>
                  <h6 className="fw-semibold mb-1">
                    SEO (Search Engine Optimization)
                  </h6>
                  <p className="mb-0 text-muted">
                    Learn how to rank websites on Google and drive organic
                    traffic.{" "}
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="d-flex align-items-center justify-content-center bg-light rounded-4 p-3 shadow-sm h-100">
                <span className=" fs-3 me-3">🧑‍🏫</span>
                <div>
                  <h6 className="fw-semibold mb-1">
                    SMO & SMM (Social Media Optimization & Marketing)
                  </h6>
                  <p className="mb-0 text-muted">
                    Master the art of social media marketing across platforms
                    like Facebook, Instagram, and LinkedIn.{" "}
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="d-flex align-items-center justify-content-center bg-light rounded-4 p-3 shadow-sm h-100">
                <span className=" fs-3 me-3">🔍</span>
                <div>
                  <h6 className="fw-semibold mb-1">Facebook & Instagram Ads</h6>
                  <p className="mb-0 text-muted">
                    Get hands-on experience running paid ad campaigns that
                    convert leads into customers.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="d-flex align-items-center justify-content-center bg-light rounded-4 p-3 shadow-sm h-100">
                <span className=" fs-3 me-3">💼</span>
                <div>
                  <h6 className="fw-semibold mb-1">Google Ads (PPC)</h6>
                  <p className="mb-0 text-muted">
                    Learn Pay-Per-Click advertising to target potential
                    customers using Google search and display networks.{" "}
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="d-flex align-items-center justify-content-center bg-light rounded-4 p-3 shadow-sm h-100">
                <span className=" fs-3 me-3">🧑‍💻</span>
                <div>
                  <h6 className="fw-semibold mb-1">
                    WordPress Website Development
                  </h6>
                  <p className="mb-0 text-muted">
                    Build stunning websites without coding using WordPress –
                    ideal for blogs, businesses, and portfolios.{" "}
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="d-flex align-items-center justify-content-center bg-light rounded-4 p-3 shadow-sm h-100">
                <span className=" fs-3 me-3">📄</span>
                <div>
                  <h6 className="fw-semibold mb-1">YouTube SEO</h6>
                  <p className="mb-0 text-muted">
                    Learn how to optimize your videos to increase views,
                    subscribers, and engagement organically{" "}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ************************* Who Can Join This Course? ************************* */}

        <div className=" p-md-5 rounded-4  mt-3 CourseDetails mt-md-5">
          <div className="row g-4 align-items-start">
            {/* *************** Who Can Join Section *************** */}
            <div className="col-md-6">
              <div className="p-3 p-md-4 h-100 rounded-4 d-flex flex-column shadow-sm border bg-light">
                <h4 className="text-primary fw-bold mb-3">
                  Who Can Join This Course?
                </h4>
                <ul className="list-unstyled mb-3 text-dark">
                  <li className="mb-2">✅ Students & Graduates</li>
                  <li className="mb-2">✅ Small Business Owners</li>
                  <li className="mb-2">✅ Homemakers</li>
                  <li className="mb-2">✅ Job Seekers</li>
                  <li className="mb-2">✅ Freelancers</li>
                  <li className="mb-2">✅ Anyone who wants to earn online</li>
                </ul>
                <p className="text-muted small mb-0">
                  No technical background? No problem! This course is designed
                  for beginners.
                </p>
              </div>
            </div>

            {/* *************** Course Fee Section *************** */}
            <div className="col-md-6">
              <div
                className="p-3 p-md-4 h-100 rounded-4 d-flex flex-column shadow-sm border"
                style={{ backgroundColor: "#fff8f4" }}
              >
                <h4 className="text-danger fw-bold mb-3">Course Fee Details</h4>
                <ul className="list-unstyled text-dark mb-3">
                  <li className="mb-2">
                    ✅ Digital Marketing Course Fee – ₹5999/- Only
                  </li>
                  <li className="mb-2">✅ Duration – 2 Months</li>
                  <li className="mb-2">✅ Mode – Online </li>
                  <li className="mb-2">✅ Language – Telugu</li>
                  <li className="mb-2">📞 Call Now: +91 88857 11171</li>
                  <li className="mb-2">
                    👉 Limited Seats Available – Apply Now!
                  </li>
                </ul>

                <div className=" d-flex  gap-2 gap-md-4 seo-button justify-content-around">
                  <button className="btn1  px-lg-4 px-3 py-2 rounded-3 shadow-sm">
                    <Link
                      to="https://forms.gle/n6jUHxwq9AtEt4ac8"
                      target="_blank"
                      className="text-decoration-none text-white"
                    >
                      Apply Now
                    </Link>
                  </button>
                  {/* <button
                    className="btn1 px-lg-4 py-2 px-3 rounded-3 shadow-sm"
                    onClick={() => handleBrochure(SEOBrochure)}
                  >
                    Download Brochure
                  </button> */}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/*   ************************************* What You Will Learn *********************************/}

        {/* <div className="bg-white p-4 p-md-5 rounded-4 shadow-sm border border-light mt-3 mt-md-5   d-flex justify-content-center flex-column mx-auto">
          <div className=" mx-auto">
            <h3 className="textColor2 fw-bold text-center mb-3 Learn mb-md-5">
              What You Will Learn ?
            </h3>
            <img
              src={SEOContent}
              alt="SEOContent Img"
              className=" img-fluid"
              style={{ width: "700px" }}
            />
          </div>
        </div> */}

        {/* ********************************  Why Choose New Directions Skills ******************************* */}

        <div className="bg-white p-2 p-md-5 rounded-4 shadow-sm border why-ndskill border-1 border-light mt-3 mt-md-5 ">
          <h3 className="text-center text-primary fw-bold  mb-3 mb-md-5">
            Why Choose <span className="text-dark">New Directions Skills?</span>
          </h3>

          <div className="row row-cols-1 row-cols-md-2 g-3 g-md-4">
            <div className="col">
              <div className="d-flex align-items-start bg-light rounded-4  border-bottom shadow-sm p-1  p-2 p-md-3 h-100 border-start border-4 border-success">
                <div className="fs-2 me-3 text-success">🗣️</div>
                <div>
                  <h6 className="fw-semibold mb-1">
                    Training in Telugu Language
                  </h6>
                  <p className="text-muted mb-0">
                    Understand every topic in your native language for better
                    clarity.
                  </p>
                </div>
              </div>
            </div>

            <div className="col">
              <div className="d-flex align-items-start bg-light border-bottom rounded-4 shadow-sm  p-2 p-md-3 h-100 border-start border-4 border-info">
                <div className="fs-2 me-3 text-info">👨‍🏫</div>
                <div>
                  <h6 className="fw-semibold mb-1">Affordable Fee</h6>
                  <p className="text-muted mb-0">
                    Full course at just ₹5999/- with no hidden charges.
                  </p>
                </div>
              </div>
            </div>

            <div className="col">
              <div className="d-flex align-items-start bg-light border-bottom rounded-4 shadow-sm  p-2 p-md-3 h-100 border-start border-4 border-warning">
                <div className="fs-2 me-3 text-warning">💰</div>
                <div>
                  <h6 className="fw-semibold mb-1">
                    2-Month Intensive Program
                  </h6>
                  <p className="text-muted mb-0">
                    We value your time! Our structured course will cover all the
                    essentials in just 60 days.
                  </p>
                </div>
              </div>
            </div>

            <div className="col">
              <div className="d-flex align-items-start bg-light rounded-4 border-bottom shadow-sm  p-2 p-md-3 h-100 border-start border-4 border-primary">
                <div className="fs-2 me-3 text-primary">🧾</div>
                <div>
                  <h6 className="fw-semibold mb-1">Practical Training</h6>
                  <p className="text-muted mb-0">
                    Real-time project-based learning to gain practical skills
                    that employers love.
                  </p>
                </div>
              </div>
            </div>

            <div className="col">
              <div className="d-flex align-items-start bg-light rounded-4 shadow-sm  p-2 p-md-3 h-100 border-start  border-bottom border-4 border-danger">
                <div className="fs-2 me-3 text-danger">🌐</div>
                <div>
                  <h6 className="fw-semibold mb-1"> Expert Trainers</h6>
                  <p className="text-muted mb-0">
                    Get trained by industry professionals with years of hands-on
                    experience.
                  </p>
                </div>
              </div>
            </div>

            <div className="col">
              <div className="d-flex align-items-start bg-light rounded-4  border-bottom shadow-sm p-1  p-2 p-md-3 h-100 border-start border-4 border-success">
                <div className="fs-2 me-3 text-success">🗣️</div>
                <div>
                  <h6 className="fw-semibold mb-1">
                    Career Guidance & Support{" "}
                  </h6>
                  <p className="text-muted mb-0">
                    We provide mentorship and support to help you start
                    freelancing or get placed in the digital marketing industry.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* <div className="mt-3 mt-md-5 text-lg-center">
            <p className="text-muted ">
              Start your digital career today with a skill that ensures future
              growth. Our <strong>SEO course in Telugu</strong> is ideal for
              beginners—even with no technical background—to confidently step
              into the world of online marketing.
            </p>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default PaidDigital;
